#import "../fragments/role-fragment.graphql"

query GetRoles {
    roles {
        ...RoleFragment
    }
}
